import z from "zod";
import { Currency } from "./enums/currency";

export const MoneyScheme = z.object({
  amount: z.number(),
  currency: z.enum(Currency),
});

export type Money = z.infer<typeof MoneyScheme>;
